import api from '@/services/Api';
import { cleanObject } from '@ifac/ui';

class Conferences {
  static all({
    page = 1,
    perPage = 25,
    direction = 'desc',
    keyword = null,
    filter = null,
  } = {}) {
    const params = cleanObject({
      page: parseInt(page, 10),
      perPage: parseInt(perPage, 10),
      direction,
      keyword,
      filter,
    });

    return api.get('/public/conferences', { params });
  }

  static show(year, { name }) {
    return api.get(`/public/conferences/${year}`, {
      params: { name },
    });
  }
}

export default Conferences;
